import { getAuthHeaders } from "../utils/authHeaders";
import { API_URL } from "../config/api";

interface UploadResponse {
  url: string;
  publicId: string;
}

export const uploadFile = async (
  file: File,
  type: "cv" | "avatar" | "logo"
): Promise<UploadResponse> => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(`${API_URL}/upload/${type}`, {
    method: "POST",
    headers: { ...getAuthHeaders() },
    credentials: "include",
    body: formData,
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Upload failed");
  }

  return response.json();
};
